module.exports = __webpack_public_path__ + "static/media/mobile01.1714b01e.jpg";